var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

module.exports = function (e) {
  var t = {};

  function l(a) {
    if (t[a]) return t[a].exports;
    var r = t[a] = {
      i: a,
      l: !1,
      exports: {}
    };
    return e[a].call(r.exports, r, r.exports, l), r.l = !0, r.exports;
  }

  return l.m = e, l.c = t, l.d = function (e, t, a) {
    l.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: a
    });
  }, l.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, l.t = function (e, t) {
    if (1 & t && (e = l(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var a = Object.create(null);
    if (l.r(a), Object.defineProperty(a, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      l.d(a, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return a;
  }, l.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return l.d(t, "a", t), t;
  }, l.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, l.p = "", l(l.s = 69);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  4: function _(e, t) {
    e.exports = require("../../utils/utils");
  },
  69: function _(e, t, l) {
    "use strict";

    var a = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var l in e) {
        Object.hasOwnProperty.call(e, l) && (t[l] = e[l]);
      }
      return t.default = e, t;
    },
        r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = a(l(1)),
        o = a(l(2)),
        u = l(70),
        s = r(l(71)),
        i = l(4),
        c = l(3),
        d = c.colorPalettes.KineduPalette,
        f = o.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n   width: calc(100% - ", "px);\n   margin-left: ", "px;\n"])), function (_ref) {
      var e = _ref.showValues,
          t = _ref.BotValues;
      return e ? t ? "margin-bottom: 40px" : "margin-top: 40px" : "";
    }, 16, 8),
        p = {
      position: "relative",
      display: "flex",
      alignItems: "center",
      width: "100%",
      height: 20
    },
        m = o.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  width: calc(100% + ", "px);\n  left: -", "px;\n"])), function (_ref2) {
      var e = _ref2.theme;
      return e.railBar;
    }, 16, 8),
        g = o.default.div.attrs(function (_ref3) {
      var e = _ref3.percent,
          t = _ref3.index;
      return {
        style: {
          left: "calc(".concat(e, "% - 8px)")
        }
      };
    })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref4) {
      var e = _ref4.theme;
      return e.handle;
    }),
        h = o.default.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: ", ";\n  position: absolute;\n  left: 50%;\n  transform: ", ";\n  color: ", ";\n  font-size: 14px;\n  line-height: 17px;\n  ", ": -100%;\n  background-color: ", ";\n  border-radius: 4px;\n  padding: 1px 8px;\n  font-style: normal;\n  font-weight: bold;\n"])), function (_ref5) {
      var e = _ref5.showValues,
          t = _ref5.onShowValues,
          l = _ref5.valuesAlwaysVisible;
      return e && l || e && t ? "inline-block" : "none";
    }, function (_ref6) {
      var e = _ref6.BotValues;
      return e ? "translate(-50%, 50%)" : "translate(-50%, -50%)";
    }, function (_ref7) {
      var e = _ref7.colorValues;
      return e || d.kinedu;
    }, function (_ref8) {
      var e = _ref8.BotValues;
      return e ? "bottom" : "top";
    }, function (_ref9) {
      var e = _ref9.bgValues;
      return e || "#EAEAEA";
    }),
        b = o.default.div.attrs(function (_ref10) {
      var e = _ref10.source,
          t = _ref10.target;
      return {
        style: {
          left: e.percent + "%",
          width: "calc(".concat(t.percent - e.percent, "%)")
        }
      };
    })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref11) {
      var e = _ref11.theme;
      return e.track;
    }),
        V = o.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  align-content: stretch;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 325;\n  line-height: 17px;\n  color: ", ";\n  margin-top: 5px;\n  padding-left: 2px;\n"])), function (_ref12) {
      var e = _ref12.colorValues;
      return e || d.shadeDark;
    }),
        x = function x(_ref13) {
      var e = _ref13.id,
          t = _ref13.value,
          l = _ref13.percent,
          a = _ref13.getHandleProps,
          r = _ref13.showValues,
          o = _ref13.onShowValues,
          u = _ref13.bgValues,
          s = _ref13.valuesAlwaysVisible,
          i = _ref13.colorValues,
          c = _ref13.BotValues,
          d = _ref13.index;
      return n.default.createElement(g, Object.assign({
        percent: l,
        index: d
      }, a(e)), t, n.default.createElement(h, {
        className: "ValueContent",
        showValues: r,
        onShowValues: o,
        bgValues: u,
        valuesAlwaysVisible: s,
        colorValues: i,
        BotValues: c
      }, t));
    },
        y = function y(_ref14) {
      var e = _ref14.source,
          t = _ref14.target,
          l = _ref14.getTrackProps;
      return n.default.createElement(b, Object.assign({
        source: e,
        target: t
      }, l()));
    };

    t.default = function (e) {
      var _e$domain = e.domain,
          t = _e$domain === void 0 ? [0, 100] : _e$domain,
          _e$step = e.step,
          l = _e$step === void 0 ? 1 : _e$step,
          _e$values = e.values,
          a = _e$values === void 0 ? [30, 70] : _e$values,
          _e$onChange = e.onChange,
          r = _e$onChange === void 0 ? function () {} : _e$onChange,
          _e$theme = e.theme,
          c = _e$theme === void 0 ? "Basic" : _e$theme,
          _e$showValues = e.showValues,
          d = _e$showValues === void 0 ? !0 : _e$showValues,
          _e$showOtherValues = e.showOtherValues,
          g = _e$showOtherValues === void 0 ? !1 : _e$showOtherValues,
          h = e.valuesAlwaysVisible,
          b = e.bgValues,
          v = e.colorValues,
          w = e.BotValues,
          _n$useState = n.useState(!1),
          _n$useState2 = _slicedToArray(_n$useState, 2),
          E = _n$useState2[0],
          P = _n$useState2[1],
          _n$useState3 = n.useState(a),
          _n$useState4 = _slicedToArray(_n$useState3, 2),
          S = _n$useState4[0],
          $ = _n$useState4[1];

      return n.default.createElement(o.ThemeProvider, {
        theme: i.isObject(c) ? c : s.default[c]
      }, n.default.createElement(f, {
        showValues: d,
        BotValues: w,
        className: "lego-ranger"
      }, n.default.createElement(u.Slider, {
        rootStyle: p,
        domain: t,
        step: l,
        mode: 2,
        values: a,
        onChange: function onChange(e) {
          $(e), r(e);
        },
        onSlideStart: function onSlideStart() {
          return P(!0);
        },
        onSlideEnd: function onSlideEnd() {
          return P(!1);
        }
      }, n.default.createElement(u.Rail, null, function (_ref15) {
        var e = _ref15.getRailProps;
        return n.default.createElement(m, Object.assign({}, e()));
      }), n.default.createElement(u.Handles, null, function (_ref16) {
        var e = _ref16.handles,
            t = _ref16.getHandleProps;
        return n.default.createElement(n.default.Fragment, null, e.map(function (e, l) {
          return n.default.createElement(x, {
            key: e.id,
            id: e.id,
            value: e.value,
            percent: e.percent,
            showValues: d,
            onShowValues: E,
            bgValues: b,
            valuesAlwaysVisible: h,
            colorValues: v,
            BotValues: w,
            getHandleProps: t,
            index: l
          });
        }));
      }), n.default.createElement(u.Tracks, {
        left: !1,
        right: !1
      }, function (_ref17) {
        var e = _ref17.tracks,
            t = _ref17.getTrackProps;
        return n.default.createElement(n.default.Fragment, null, e.map(function (_ref18) {
          var e = _ref18.id,
              l = _ref18.source,
              a = _ref18.target;
          return n.default.createElement(y, {
            key: e,
            source: l,
            target: a,
            getTrackProps: t
          });
        }));
      })), g ? n.default.createElement(V, null, n.default.createElement("span", null, S[0]), n.default.createElement("span", null, S[1])) : null));
    };
  },
  70: function _(e, t) {
    e.exports = require("react-compound-slider");
  },
  71: function _(e, t) {
    e.exports = require("../../themes/Ranger.theme");
  }
});